import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { changePassword } from "../services/api"; // Import change password API

function Dashboard() {
  const navigate = useNavigate();
  const userRole = sessionStorage.getItem("userRole");

  // State for the change password modal
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Function to handle password change
  const handleChangePassword = async () => {
    setError("");
    setSuccess("");
    try {
      await changePassword(oldPassword, newPassword);
      setSuccess("Password changed successfully!");
      setOldPassword("");
      setNewPassword("");
      setTimeout(() => setShowPasswordModal(false), 1500); // Close modal after success
    } catch (err) {
      setError("Failed to change password. Please try again.");
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Quiz Management Dashboard</h1>

      <section style={styles.welcomeSection}>
        <h2 style={styles.subtitle}>Welcome to the Quiz Dashboard</h2>
        <p style={styles.description}>
          Here, you can view, edit, and manage all quizzes. Use the options below to create new quizzes, 
          view existing ones, or review quiz statistics.
        </p>
      </section>

      <section style={styles.createQuizSection}>
        <button style={styles.button} onClick={() => navigate("/create-quiz")}>
          + Create New Quiz
        </button>

        {userRole === "super_admin" && (
          <>
            <button
              style={{ ...styles.button, backgroundColor: "#28a745" }}
              onClick={() => navigate("/add-admin")}
            >
              + Add Admin User
            </button>
            <button
              style={{ ...styles.button, backgroundColor: "#17a2b8" }}
              onClick={() => navigate("/admin-list")}
            >
              Show Admin Users
            </button>
          </>
        )}

        {userRole === "admin" && (
          <>
            <button
              style={{ ...styles.button, backgroundColor: "#28a745" }}
              onClick={() => navigate("/add-admin")}
            >
              + Add User
            </button>
            <button
              style={{ ...styles.button, backgroundColor: "#17a2b8" }}
              onClick={() => navigate("/user-list")}
            >
              Show Users
            </button>
          </>
        )}

        {/* Change Password Button */}
        <button
          style={{ ...styles.button, backgroundColor: "#ffc107" }}
          onClick={() => setShowPasswordModal(true)}
        >
          Change Password
        </button>

{userRole === "super_admin" && (
          <>
            <button
              style={{ ...styles.button, backgroundColor: "#28a745" }}
              onClick={() => navigate("/prize-list")}
            >
              + Add Prize List
            </button>
           
          </>
        )}



      </section>

      {/* Change Password Modal */}
      {showPasswordModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <h3 style={styles.modalTitle}>Change Password</h3>
            {error && <p style={styles.error}>{error}</p>}
            {success && <p style={styles.success}>{success}</p>}
            <input
              type="password"
              placeholder="Old Password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              style={styles.input}
            />
            <input
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              style={styles.input}
            />
            <div style={styles.buttonGroup}>
              <button style={{ ...styles.button, width: "100%" }} onClick={handleChangePassword}>
                Update Password
              </button>
              <button style={{ ...styles.closeButton, width: "100%" }} onClick={() => setShowPasswordModal(false)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// Styles
const styles = {
  container: {
    padding: "30px",
    backgroundColor: "#f4f4f4",
    borderRadius: "10px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
    maxWidth: "900px",
    margin: "20px auto",
    textAlign: "center",
  },
  title: {
    fontSize: "34px",
    color: "#333",
    marginBottom: "20px",
    fontWeight: "bold",
  },
  welcomeSection: {
    marginBottom: "30px",
    padding: "20px",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    textAlign: "left",
  },
  subtitle: {
    fontSize: "26px",
    color: "#444",
    marginBottom: "10px",
    fontWeight: "600",
  },
  description: {
    fontSize: "18px",
    color: "#666",
    lineHeight: "1.6",
  },
  createQuizSection: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "12px",
    marginTop: "20px",
  },
  button: {
    padding: "12px 25px",
    fontSize: "18px",
    cursor: "pointer",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    transition: "background-color 0.3s, transform 0.2s",
    boxShadow: "0 3px 6px rgba(0, 0, 0, 0.2)",
    minWidth: "200px",
    textTransform: "uppercase",
    fontWeight: "bold",
  },
  buttonHover: {
    backgroundColor: "#0056b3",
    transform: "scale(1.05)",
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "#fff",
    padding: "30px",
    borderRadius: "10px",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
    textAlign: "center",
    minWidth: "400px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  modalTitle: {
    fontSize: "22px",
    marginBottom: "20px",
    color: "#333",
    fontWeight: "bold",
  },
  input: {
    width: "90%",
    padding: "12px",
    margin: "10px 0",
    fontSize: "16px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    outline: "none",
    textAlign: "left",
    backgroundColor: "#f9f9f9",
    transition: "border-color 0.3s",
  },
  inputFocus: {
    borderColor: "#007bff",
    boxShadow: "0 0 5px rgba(0, 123, 255, 0.5)",
  },
  buttonGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    width: "100%",
  },
  closeButton: {
    padding: "12px 20px",
    backgroundColor: "#dc3545",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    borderRadius: "8px",
    transition: "background-color 0.3s",
    fontWeight: "bold",
  },
  closeButtonHover: {
    backgroundColor: "#a71d2a",
  },
  error: {
    color: "red",
    fontWeight: "bold",
    fontSize: "14px",
    marginBottom: "10px",
  },
  success: {
    color: "green",
    fontWeight: "bold",
    fontSize: "14px",
    marginBottom: "10px",
  },
};

export default Dashboard;
